import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AsyncAuthProvider } from './AsyncAuthProvider';
import 'bootstrap/dist/css/bootstrap.css';
import { BankProvider } from './BankContext';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { Accounts } from './Accounts';
import { SpendingLog } from './SpendingLog';
import { Root } from './Root';
import { Savings } from './savings/Savings';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "",
        element: <Navigate replace to="/spending-log" />,
      },
      {
        path: "/spending-log",
        element: <SpendingLog />
      },
      {
        path: "/accounts",
        element: <Accounts />,
      },
      {
        path: "/savings",
        element: <Savings />,
      }
    ]
  },
  {
    path: "/signed-in",
    element: <Navigate to="/" />
  },
  {
    path: "/signed-out",
    element: <Navigate to="/" />
  }
]);

root.render(
  <React.StrictMode>
    <AsyncAuthProvider>
      <BankProvider>
        <RouterProvider router={router} />
      </BankProvider>
    </AsyncAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
